import { packagesActions } from '@src/store/reducers/packagesReducer';
import { Component, Inject, OnDestroy } from '@angular/core';
import { Store } from '@src/store';

@Component({
    selector: 'deployed-packages',
    template: require('./deployed-packages.component.html'),
    styles: [require('./deployed-packages.component.scss')]
})
export class DeployedPackagesComponent implements OnDestroy{

    private readonly PAGE_SIZE = 50;
    public isHistory: boolean;
    public criteria: any = { data: { fromDate: null, toDate: new Date(), filterText: '',
        selectedFilterOption: 2 }, isHistory: this.isHistory };

    public projectId: any;
    public environmentId: any;

    public isCollapsed: boolean = true;
    public tableData: any;

    constructor(private store: Store,
                @Inject('$stateParams') stateParams: any) {
        this.isHistory = !!this.store.getState().projects.projectWithMetaData &&
            this.store.getState().projects.projectWithMetaData.dplModeType === 2;
        this.projectId = stateParams.id;
        this.environmentId = stateParams.envID;
        this.runCriteria();
    }

    public filter(criteria) {
        criteria.isHistory = this.isHistory;
        this.criteria = criteria;
        this.getRecords();
    }

    public runCriteria() {
        this.criteria.isHistory = this.isHistory;
        this.getRecords();
    }

    public ngOnDestroy(): void {
        this.store.dispatch({ type: packagesActions.RESET_DEPLOYED_PACKAGES_DATA });
    }

    public getRecords (page = 0) {
        const pageNumber = page || 0;
        const payload = {
            pageNumber,
            startDate: this.criteria.data.fromDate,
            endDate: this.criteria.data.toDate,
            filterText: this.criteria.data.filterText,
            projectId: this.projectId,
            environmentId: this.environmentId,
            pageSize: this.PAGE_SIZE,
            filterOption: this.criteria.data.selectedFilterOption
        };
        let type = packagesActions.GET_EFFECTIVE_DEPLOYED_PACKAGES;
        if (this.isHistory === true) {
            type = packagesActions.GET_EFFECTIVE_DEPLOYED_PACKAGES_HISTORY;
        }
        this.store.dispatch({ type, payload }).then((res) => {
            if (res) {
                this.tableData = res.data;
            }
        });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/deployed-packages/deployed-packages.component.ts